module.exports = __webpack_public_path__ + "static/img/ActivePush.2e6a69af.png";